import { Reveal } from "../components/Reveal";
import { useModal } from "../context/ModalContext";
import { Quote, ShieldCheck, Star, Languages, Clock } from "lucide-react";

const INSTRUCTOR_IMG = "https://images.unsplash.com/photo-1593035013811-2db9b3c36980?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export function MeetInstructor() {
  const { open } = useModal();
  return (
    <section id="instructor" className="section-pad bg-neutral-900 text-white relative overflow-hidden grain" data-testid="instructor-section">
      <div className="absolute -top-24 right-0 w-96 h-96 rounded-full brand-gradient opacity-20 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="relative">
            <div className="rounded-[2rem] overflow-hidden shadow-soft-lg max-w-md">
              <img src={INSTRUCTOR_IMG} alt="DVSA-approved lead driving instructor at S-UK Driving School in Northolt, West London" className="w-full h-80 sm:h-[460px] object-cover" loading="lazy" />
            </div>
            <div className="absolute -right-2 bottom-8 card-soft !bg-white p-4 flex items-center gap-3 text-neutral-900">
              <Star size={22} className="fill-brand-amber text-brand-amber" />
              <div><p className="font-bold leading-none">4.9 / 5</p><p className="text-xs text-neutral-500">320+ reviews</p></div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <span className="overline">Meet Your Instructor</span>
          <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">
            Patient, friendly &amp; <span className="brand-text">DVSA approved</span>
          </h2>
          <p className="mt-5 text-neutral-300 leading-relaxed max-w-lg">
            With 37+ years of experience teaching learners across Northolt, Greenford, Southall and South Harrow, our lead instructor blends
            calm patience with structured, proven methods. Whether you're a nervous first-timer or need a confidence refresher,
            you're in expert hands from your very first lesson.
          </p>
          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            {[
              { icon: ShieldCheck, t: "DVSA Approved", s: "Fully qualified ADI" },
              { icon: Languages, t: "Multilingual", s: "English, Hindi, Punjabi and Urdu" },
              { icon: Clock, t: "37+ Years", s: "Experience" },
            ].map((x) => (
              <div key={x.t} className="rounded-2xl bg-white/5 border border-white/10 p-4">
                <x.icon size={22} className="text-brand-orange mb-2" strokeWidth={1.8} />
                <p className="font-semibold text-sm">{x.t}</p>
                <p className="text-xs text-neutral-400">{x.s}</p>
              </div>
            ))}
          </div>
          <button className="btn-primary mt-8" onClick={() => open("booking")} data-testid="instructor-book-btn">
            <Quote size={16} /> Book with our instructor
          </button>
        </Reveal>
      </div>
    </section>
  );
}
